import { useEffect } from 'react';
import { Modal, Button, Input, Table, Form, Slider, Typography } from 'antd';
import { CarregarProcessos, ShowProgressoObra } from '@actions/casasActions';
import { AddObra, GetObra, DeleteObra, ChangeOrder, ChangeProgresso } from '@actions/obraActions';
import { DeleteOutlined, ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';
import { ProcessoEmpreendimento } from '@models/ProcessoEmpreendimento';
import { useAppDispatch, useAppSelector } from '@config/reduxStore';

function ProgressoObra() {
    const dispatch = useAppDispatch();
    const { obramodal, fichaImovel, casas, feedback, loadingprocessos } = useAppSelector((state) => state.casas);
    const obra = useAppSelector((state) => state.obra);

    const [form] = Form.useForm();
    const submitForm = (values: ProcessoEmpreendimento) => {
        dispatch(AddObra(values.descricao, fichaImovel.id, 1));
    };
    useEffect(() => {
        form.resetFields();
        dispatch(GetObra(fichaImovel.id));
    }, [fichaImovel, casas, form]);

    return (
        <Modal
            title="Progresso da obra"
            open={obramodal}
            onCancel={() => dispatch(ShowProgressoObra(null, false))}
            footer={[
                <Typography.Text key="1" type="danger">
                    {feedback}
                </Typography.Text>,
                <Button key="2" onClick={() => dispatch(ShowProgressoObra(null, false))}>
                    Fechar
                </Button>,
                obra.items.length === 0 ? (
                    <Button
                        loading={loadingprocessos}
                        key="3"
                        type="primary"
                        onClick={() => dispatch(CarregarProcessos(fichaImovel.id))}
                    >
                        Carregar Processos
                    </Button>
                ) : (
                    ''
                ),
            ]}
        >
            <div>
                <h3>Progresso da Obra</h3>
                <Form onFinish={submitForm} name="obraForm" form={form}>
                    <Form.Item name="descricao" rules={[{ required: true, message: 'Descrição em branco' }]}>
                        <Input.Search
                            placeholder="Descrição"
                            onSearch={() => form.submit()}
                            enterButton="Adicionar"
                            size="small"
                            loading={obra.obrasaving}
                        />
                    </Form.Item>
                </Form>
                <Table pagination={false} loading={obra.loading} size="small" rowKey="id" dataSource={obra.items}>
                    <Table.Column
                        width={120}
                        render={(_, row: ProcessoEmpreendimento, index) => (
                            <div>
                                <Button
                                    size="small"
                                    icon={<DeleteOutlined />}
                                    onClick={() => dispatch(DeleteObra(row.id))}
                                />
                                {index > 0 && (
                                    <Button
                                        size="small"
                                        icon={<ArrowUpOutlined />}
                                        onClick={() => dispatch(ChangeOrder(fichaImovel.id, row.id, true))}
                                    />
                                )}
                                {index + 1 < obra.items.length && (
                                    <Button
                                        size="small"
                                        icon={<ArrowDownOutlined />}
                                        onClick={() => dispatch(ChangeOrder(fichaImovel.id, row.id, false))}
                                    />
                                )}
                            </div>
                        )}
                    />
                    <Table.Column title="Item" render={(_, __, index) => index + 1} />
                    <Table.Column title="Descrição" dataIndex="descricao" />
                    <Table.Column
                        width={150}
                        title="Progresso"
                        dataIndex="progresso"
                        render={(_, row: ProcessoEmpreendimento) => (
                            <Slider
                                style={{ marginRight: 30 }}
                                step={10}
                                marks={{ 0: '0%', 50: '50%', 100: '100%' }}
                                value={obra.items.find((c) => c.id === row.id).progresso}
                                onChange={(value: number) => dispatch(ChangeProgresso(row.id, value))}
                            />
                        )}
                    />
                </Table>
            </div>
        </Modal>
    );
}

export default ProgressoObra;
